<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-select-input
              v-model="filter.keyword"
              :options="option.keyword"
              :width="['100px', '150px']"
          ></gj-select-input>
          <gj-supplier-select
              v-model="filter.supplierCode"
              placeholder="供应商"
          ></gj-supplier-select>
          <gj-date-picker
              v-model="filter.date"
              tooltip="创建时间"
              type="daterange"
          ></gj-date-picker>
          <template #right>
            <gj-tool-group
                help
            ></gj-tool-group>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :name="tableName"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :scroll-x="{gt: -1}"
            :scroll-y="{gt: -1}"
            :extend-row-config="{prop: 'extendRow'}"
            :structure-config="{type: 'ParentChild', children: 'items', parentSpan: [0, 4]}"
            sortable="custom"
            :show-overflow="false"
            :pagination="pagination"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:picture="{row}">
            <template v-if="row.$gjParentData">
              <div style="display: inline-block; width: 160px;">
                {{row.code | defaultShow}}
                <gj-copy-icon :content="row.code" />
              </div>
              <div v-gutter="20" style="display: inline-block;">
                <span><span class="parent-table-label">创建时间：</span>{{row.createTime | defaultShow}}</span>
                <span><span class="parent-table-label">供应商：</span>{{row.supplierName | defaultShow}}</span>
                <span><span class="parent-table-label">总金额：</span>{{row.oldTotalAmount | amount | defaultShow(row.currencySymbol)}} -> {{row.newTotalAmount | amount | defaultShow(row.currencySymbol)}}</span>
                <span><span class="parent-table-label">创建人：</span>{{row.craeteUserName | defaultShow}}</span>
                <span><span class="parent-table-label">采购员：</span>{{row.buyer | defaultShow}}</span>
              </div>
            </template>
            <template v-else>
              <gj-image :src="row.smallImageUrl"></gj-image>
            </template>
          </template>
          <template v-slot:sku="{row}">
            <div>{{row.productName | defaultShow}}</div>
            <div>{{row.sku | defaultShow}}</div>
          </template>
          <template v-slot:actualPrice="{row}">
            {{row.originalIncludeTaxPrice | amount | defaultShow(row.currencySymbol)}} -> {{row.newIncludeTaxPrice | amount | defaultShow(row.currencySymbol)}}
          </template>
          <template v-slot:orderQuantity="{row}">
            {{row.originalOrderQuantity | defaultShow}} -> {{row.newOrderQuantity | defaultShow}}
          </template>
          <template v-slot:amount="{row}">
            {{row.oldAmount | amount | defaultShow(row.currencySymbol)}} -> {{row.newAmount | amount | defaultShow(row.currencySymbol)}}
          </template>
          <template v-slot:extend:row="{row}">
            <div class="default">
              <div v-if="!row.expand">
                <gj-link type="default" @click="openDetail(row,true)">
                  更多（共{{row.num}}条）
                  <i class="iconfont iconzhankai"></i>
                </gj-link>
              </div>
              <div v-else>
                <gj-link type="default" @click="openDetail(row, false)">
                  收起
                  <i class="iconfont iconshouqi"></i>
                </gj-link>
              </div>
            </div>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin, selectionMixin, valueCheckMixin} from "../../../../minxins";
  import {getPurchaseOrderChangePage} from "../../../../api/purchase";
  import {convertToDate} from "../../../../utils/date.util";

  export default {
    name: "app-purchase-order-change",
    mixins: [queryMixin, selectionMixin, responseMixin, valueCheckMixin],
    data() {
      return {
        tableName: 'purchaseOrderChange',
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'slot:picture', width: '50px'},
          {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '300px'},
          {id: 'actualPrice', header: '含税单价', field: 'slot:actualPrice', minWidth: '200px'},
          {id: 'orderQuantity', header: '采购量', field: 'slot:orderQuantity', minWidth: '200px'},
          {id: 'amount', header: '金额', field: 'slot:amount', minWidth: '200px'}
        ],
        filter: {},
        option: {
          keyword: [
            {id: 'code', text: '变更单号'},
            {id: 'purchaseOrderCode', text: '采购单号'},
            {id: 'sku', text: 'SKU'},
            {id: 'productName', text: '产品名称'},
            {id: 'supervisor', text: '采购员'},
            {id: 'createUser', text: '创建人'},
          ],
        },
        notStorage: true
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            date: null,
            supplierCode: null,
            keyword: {
              key: 'code',
              value: null
            },
          },
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            [this.filter.keyword.key]: this.filter.keyword.value,
            supplierCode: this.filter.supplierCode,
            startCreateTime: this.filter.date ? convertToDate(this.filter.date[0]) : null,
            endCreateTime: this.filter.date ? convertToDate(this.filter.date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getPurchaseOrderChangePage(params)
          .then((data) => {
            this.tableData = data.records.map((v, i) => {
              const items = this._.cloneDeep(v.items)
              return Object.assign(v, {
                productsCopy: items,
                items: items.slice(0, 3),
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      openDetail(row, flag){
        if (flag) {
          row.items = row.productsCopy;
          row.expand = flag;
        } else {
          row.items = row.items.slice(0,3);
          row.expand = flag;
        }
        this.tableData = this.tableData.map(v => {
          if (v.id === row.id) {
            v.expand = row.expand
            v.items = row.items
          }
          return v
        })
      }
    }
  }
</script>

<style scoped>
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}
</style>

